export function useCookieModal() {
  const open = useState<boolean>('cookie-modal-open', () => false)

  function openModal() {
    open.value = true
  }

  function closeModal() {
    open.value = false
  }

  return {
    open,
    openModal,
    closeModal,
  }
}
